import { createFileRoute } from '@tanstack/react-router';
import { clustersListOptions, toClustersQueries } from '@/features/clusters/api';
import { ClustersPage } from '@/features/clusters/ClustersPage';
import { marketsQueryOptions, readStoredMarket, resolveMarketId } from '@/lib/market';
import { CLUSTERS_SEARCH_DEFAULTS, ClustersSearch, stripDefaults } from '@/lib/search-schemas';

export const Route = createFileRoute('/_auth/clusters/')({
  validateSearch: ClustersSearch,
  search: { middlewares: [stripDefaults(ClustersSearch, CLUSTERS_SEARCH_DEFAULTS)] },
  loaderDeps: ({ search }) => search,
  // Préchargement ; les erreurs sont laissées à `useQueries` dans la page (`ErrorState`).
  loader: async ({ context, deps }) => {
    const markets = await context.queryClient
      .ensureQueryData(marketsQueryOptions())
      .catch(() => undefined);
    const marketId = resolveMarketId({
      fromSearch: deps.market,
      stored: readStoredMarket(),
      markets,
    });
    if (!marketId) return;
    await Promise.all(
      toClustersQueries(deps, marketId).map((query) =>
        context.queryClient.ensureQueryData(clustersListOptions(query)).catch(() => undefined),
      ),
    );
  },
  component: ClustersPage,
});
